/** Indian-format rupee amount, e.g. ₹1,20,000 */
const formatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

export const formatMoney = (value) => formatter.format(Number(value) || 0);

const Money = ({ value }) => <>{formatMoney(value)}</>;

export default Money;
